import { render } from "./ImageVerificationHeader.vue?vue&type=template&id=04de8846&scoped=true"
import script from "./ImageVerificationHeader.vue?vue&type=script&lang=js"
export * from "./ImageVerificationHeader.vue?vue&type=script&lang=js"

import "./ImageVerificationHeader.vue?vue&type=style&index=0&id=04de8846&scoped=true&lang=scss"

import exportComponent from "/var/www/spom.vh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04de8846"]])

export default __exports__